import * as React from "react";
const SvgFiRrImagesUser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 2h-9C7.243 2 5 4.243 5 7v6c0 2.757 2.243 5 5 5h9c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5m-6.95 14c.232-1.14 1.242-2 2.45-2s2.217.86 2.45 2zM22 13c0 1.654-1.346 3-3 3h-.028c-.25-2.247-2.16-4-4.472-4a4.506 4.506 0 0 0-4.472 4H10c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h9c1.654 0 3 1.346 3 3zm-4 8a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5v-6c0-1.234.453-2.419 1.276-3.338a1 1 0 0 1 1.489 1.336A3 3 0 0 0 1.999 11v6c0 1.654 1.346 3 3 3h12A1 1 0 0 1 18 21M17 8.5c0 1.379-1.121 2.5-2.5 2.5A2.5 2.5 0 0 1 12 8.5C12 7.121 13.121 6 14.5 6S17 7.121 17 8.5"
    />
  </svg>
);
export default SvgFiRrImagesUser;
